import React from 'react';
import { motion } from 'framer-motion';
import { Palette } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

interface ThemeToggleProps {
  className?: string;
  style?: React.CSSProperties;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '', style }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <motion.button
      onClick={toggleTheme}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      style={style}
      className={`w-10 h-10 rounded-full bg-[#121620] border border-white/[0.08] hover:border-purple-500/40 hover:bg-[#181D2A] flex items-center justify-center transition-colors shadow-sm ${className}`}
      aria-label={`Current theme: ${theme}. Click to switch.`}
      title={`Current: ${theme}. Click to cycle.`}
    >
      <Palette className="w-5 h-5 text-purple-400" />
    </motion.button>
  );
};
